module.exports = __webpack_public_path__ + "img/print-slash.bdd0ab41.svg";